import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import {
    Grid,
    Typography,
    Button,
    Table,
    TableBody,
    TableContainer,
    TableCell,
    TableHead,
    TableRow,
    Paper,
    TextField,
    FormControlLabel,
    Checkbox,
    CircularProgress, Box
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { getVenda, registrarNotaFiscalDoPedido, registrarIsentoNotaFiscalDoPedido } from '../../store/actions/vendas';
import { toggleShowDialog } from '../../store/actions/dialog';
import { PictureAsPdf, NoteAdd } from '@material-ui/icons';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';

import TituloPagina from '../../components/layout/TituloPagina';
import moedaBr from '../../assets/js/moedaBr';
import DialogAlert from '../../components/layout/DialogAlert';
import normalizarTitulo from '../../assets/js/normalizarTitulo';

const useStyles = makeStyles((theme) => ({

    fileInput: {
        display: 'none',
    },
    uploadButton: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
    },
    filePreview: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1),
        backgroundColor: theme.palette.background.default,
        borderRadius: theme.shape.borderRadius,
        marginTop: theme.spacing(1),
    },
    pdfIcon: {
        color: theme.palette.error.main,
        marginRight: theme.spacing(1),
    },

    wrapper: {
        position: 'relative',
    },
    buttonProgress: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12,
    },
}));

const DetalharVenda = (props) => {
    const history = useHistory();
    const location = useLocation();
    const {
        toggleShowDialog,
        getVenda,
        registrarNotaFiscalDoPedido,
        registrarIsentoNotaFiscalDoPedido,
        venda,
    } = props;
    const classes = useStyles();
    const [toggleDadosFaturamentoPedidoDialog, setToggleDadosFaturamentoPedidoDialog] = useState(false);
    const [isentoCodigoNFe, setIsentoCodigoNFe] = useState(false);
    const [chaveAcesso, setChaveAcesso] = useState('');
    const [arquivo, setArquivo] = useState(null);
    const [nomeArquivo, setNomeArquivo] = useState('');
    const [loading, setLoading] = useState(false);
    const [erro, setErro] = useState('');
    const id = Number(location?.state?.pedidoVendedorId);
    const isEditRoute = location.pathname === '/detalhar-venda';
    const from = location.state?.from;

    useEffect(() => {
        if (isEditRoute && !id) {
            history.replace(from);
            return;
        }

        if (id > 0) {
            getVenda(id);
        }
    }, [getVenda, history, location]);

    const handleChangeIsentoNFe = (event) => {
        setIsentoCodigoNFe(event.target.checked);
    };

    const handleEnviarNotaFiscal = (id) => {
        toggleShowDialog(id);
        setToggleDadosFaturamentoPedidoDialog(true);
    }

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type !== 'application/pdf') {
                setErro('Por favor, selecione apenas arquivos PDF.');
                setArquivo(null);
                setNomeArquivo('');
                return;
            }
            if (file.size > 5 * 1024 * 1024) { // Limite de 5MB
                setErro('O arquivo é muito grande. O limite é 5MB.');
                setArquivo(null);
                setNomeArquivo('');
                return;
            }
            setErro('');
            setArquivo(file);
            setNomeArquivo(file.name);
        }
    };

    const handleSubmit = async (event) => {
        setLoading(true);
        setErro('');

        try {
            if (isentoCodigoNFe) {
                await registrarIsentoNotaFiscalDoPedido(id);
                setToggleDadosFaturamentoPedidoDialog(false);
            } else {
                // Validação básica da chave (44 dígitos)
                const chaveLimpa = chaveAcesso.replace(/\s/g, '');
                if (chaveLimpa.length !== 44 || isNaN(chaveLimpa)) {
                    setErro('A chave de acesso deve conter exatamente 44 números.');
                    setLoading(false);
                    return;
                }

                if (!arquivo) {
                    setErro('Por favor, faça o upload do arquivo PDF da nota.');
                    setLoading(false);
                    return;
                }

                // Preparação do FormData para envio híbrido (Texto + Arquivo)
                const formData = new FormData();
                formData.append('chaveAcesso', chaveLimpa);
                formData.append('arquivoPdf', arquivo);
                formData.append('pedidoId', id);
                // Substitua pela URL da sua API Spring Boot
                await registrarNotaFiscalDoPedido(formData, id);
                setToggleDadosFaturamentoPedidoDialog(false);
            }

        } catch (err) {
            console.error(err);
            setErro(err.response?.data?.message || 'Erro ao enviar a nota fiscal. Tente novamente.');
        } finally {
            setLoading(false);
        }
    };


    const handleListarProdutosPedido = (produtos) => {
        return produtos?.map(produto => {
            const { variacoes } = produto;
            return variacoes?.map(v => {
                return (
                    <TableRow key={v.id} sx={{ '&:last-child td, &:last-child th': { border: 0 } }} style={{ backgroundColor: '#FFF' }}>
                        <TableCell component='th' scope='row' align='center'>{produto.idProduto}</TableCell>
                        <TableCell align='left'>{`${produto.nomeProduto} `}
                            {v.codigoTamanho > 1 ? `${v.tamanho}/` : null}
                            {v.codigoEstampa > 1 ? `${v.estampa}/` : null}
                            {v.codigoCor > 1 ? v.cor : null}<br />
                        </TableCell>
                        <TableCell align='center'>{produto.unidadeMedida}</TableCell>
                        <TableCell align='center'>{v.quantidade}</TableCell>
                        <TableCell align='right'>{moedaBr(v.precoUnitarioProduto)}</TableCell>
                        <TableCell align='right'>{moedaBr(v.precoTotalProduto)}</TableCell>
                    </TableRow>
                )
            })
        })
    }

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4, height: '70vh' }}>
                <CircularProgress size={48} />
            </Box>
        );
    }

    return (
        <>
            <TituloPagina titulo={`Detalhar Venda - Pedido #${venda?.subPedidoId}`} subtitulo={new Date().toLocaleString('pt-BR')} />
            <Grid container item style={{ paddingBottom: '15px', justifyContent: 'flex-end' }}>
                <Grid item style={{ paddingRight: 10 }}>
                    <Button
                        variant='contained'
                        color='secondary'
                        startIcon={<NoteAdd />}
                        disabled={venda?.linkEtiquetaFrete != null}
                        onClick={() => handleEnviarNotaFiscal(venda.subPedidoId)}
                    >
                        Informar NFe
                    </Button>
                </Grid>

                <Grid item >
                    <Button
                        variant='contained'
                        color='secondary'
                        startIcon={<PictureAsPdf />}
                        disabled={venda?.linkEtiquetaFrete == null}
                        component='a'
                        href={venda?.linkEtiquetaFrete}
                        target='_blank'
                        rel='noopener noreferrer' // Importante por segurança ao usar _blank
                    >
                        Etiqueta Para Frete
                    </Button>
                </Grid>
            </Grid>


            <Grid container item >
                <Grid item xs >
                    <Grid container item >
                        <Grid item xs={6}>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>Data/Hora do Pedido</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>{venda?.instantePedido}</Typography>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>Status do Pedido</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>{venda?.statusEntrega}</Typography>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>Cliente</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>{venda?.nomeCompletoUsuario}</Typography>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>CPF/CNPJ</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>{venda?.cpfOuCnpjUsuario}</Typography>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>Endereço</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>{venda?.enderecoParaEntrega}</Typography>

                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>Forma de Pagamento</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>{venda?.metodoPagamento ? venda?.metodoPagamento === 'CARD' ? 'Cartão de Crédito' : normalizarTitulo(venda?.metodoPagamento) : 'Pendente'}</Typography>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>Total do Pedido</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>{moedaBr(venda?.valorTotalBruto)}</Typography>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>Descontos</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>{moedaBr(venda?.valorTotalDesconto)}</Typography>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>Valor Líquido</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>{moedaBr(venda?.valorTotalBruto - venda?.valorTotalDesconto)}</Typography>
                            <Typography variant='body2' style={{ fontWeight: 'bold' }}>Chave de Acesso NFe</Typography>
                            <Typography variant='subtitle1' style={{ color: '#777777', paddingBottom: '7px' }}>
                                {venda?.chaveAcessoNfe == null ? 'Pedido ainda não faturado' : venda?.chaveAcessoNfe}
                            </Typography>
                            {venda?.chaveAcessoNfe && venda?.chaveAcessoNfe !== 'Isento'
                                ?
                                <Button
                                    variant='contained'
                                    color='secondary'
                                    startIcon={<PictureAsPdf />}
                                    component='a'
                                    href={venda?.arquivoNfe}
                                    target='_blank'
                                    rel='noopener noreferrer' // Importante por segurança ao usar _blank
                                >
                                    NFe
                                </Button>
                                :
                                null}
                        </Grid>
                    </Grid>
                    <Grid container item style={{ marginTop: 35 }}>
                        <Grid item xs >
                            <Typography variant='h6' align='center' style={{ fontWeight: 'bold' }}>Produtos do Pedido</Typography>
                        </Grid>
                    </Grid>

                    <TableContainer component={Paper} style={{ marginTop: 15 }}>
                        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                            <TableHead style={{ backgroundColor: '#ccc' }}>
                                <TableRow>
                                    <TableCell align='center' width={50} style={{ fontWeight: 'bold' }}>ID</TableCell>
                                    <TableCell align='left' style={{ fontWeight: 'bold' }}>Produto</TableCell>
                                    <TableCell align='center' width={50} style={{ fontWeight: 'bold' }}>Unidade</TableCell>
                                    <TableCell align='center' width={150} style={{ fontWeight: 'bold' }}>Quantidade</TableCell>
                                    <TableCell align='right' width={150} style={{ fontWeight: 'bold' }}>Preço Unitário</TableCell>
                                    <TableCell align='right' width={150} style={{ fontWeight: 'bold' }}>SubTotal</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {handleListarProdutosPedido(venda?.produtos)}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Grid>
                <Grid container pt={4} style={{ paddingTop: '25px', paddingBottom: '25px' }}>
                    <Grid item >
                        <Button color='secondary' variant='contained' onClick={() => history.goBack()}>Voltar</Button>
                    </Grid>
                </Grid>
            </Grid>

            <DialogAlert
                title={`Dados de Faturamento - Pedido # ${venda?.subPedidoId}`}
                fullWidth={true}
                maxWidth='sm'
                okButton={true}
                okButtonType='submit'
                okButtonClick={() => handleSubmit()}
                labelOkButton='Enviar e Salvar'
                cancelButton={true}
                cancelButtonClick={() => setToggleDadosFaturamentoPedidoDialog(false)}
                labelCancelButton='Cancelar'
                openDialog={toggleDadosFaturamentoPedidoDialog}
            >

                <Grid container item style={{ paddingTop: '15px' }}>
                    <Grid item xs >
                        <Typography variant='subtitle1' style={{ color: '#999997' }}>Cole no campo abaixo o código da NFe do pedido. Esse código é obrigatório para vendedor PJ.</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <TextField
                                    variant='filled'
                                    required
                                    fullWidth
                                    id='chaveAcesso'
                                    label='Chave de Acesso NFe (44 dígitos)'
                                    name='chaveAcesso'
                                    value={chaveAcesso}
                                    onChange={(e) => setChaveAcesso(e.target.value)}
                                    inputProps={{ maxLength: 44 }}
                                    error={!!erro && erro.includes('chave')}
                                    helperText='Copie a chave sem espaços presente no DANFE'
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <Typography variant='subtitle2' gutterBottom>
                                    Arquivo PDF da Nota (DANFE) *
                                </Typography>
                                <input
                                    accept='application/pdf'
                                    className={classes.fileInput}
                                    id='contained-button-file'
                                    type='file'
                                    onChange={handleFileChange}
                                />
                                <label htmlFor='contained-button-file'>
                                    <Button
                                        variant='outlined'
                                        color='default'
                                        component='span'
                                        startIcon={<CloudUploadIcon />}
                                        className={classes.uploadButton}
                                        fullWidth
                                    >
                                        Selecionar PDF
                                    </Button>
                                </label>

                                {nomeArquivo && (
                                    <Box className={classes.filePreview}>
                                        <PictureAsPdfIcon className={classes.pdfIcon} />
                                        <Typography variant='body2' noWrap>
                                            {nomeArquivo}
                                        </Typography>
                                    </Box>
                                )}
                            </Grid>

                            <Grid item xs={12} sm={12} style={{ padding: '5px' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isentoCodigoNFe}
                                            onChange={handleChangeIsentoNFe}
                                            name='isentoCodigoNFe'
                                            indeterminate
                                        />
                                    }
                                    label='Sou Pessoa Física e desejo usar Declaração de Conteúdo.'
                                />
                            </Grid>

                            {erro && (
                                <Grid item xs={12}>
                                    <Typography color='error' variant='body2' align='center'>
                                        {erro}
                                    </Typography>
                                </Grid>
                            )}
                        </Grid>

                    </Grid>
                </Grid>
            </DialogAlert>


        </>
    )
}

const mapStateToProps = state => ({
    idDialogShow: state.dialog.idDialogShow,
    venda: state.venda.venda,
    loading: state.venda.loading
})
const mapDispatchToProps = dispatch => bindActionCreators({
    toggleShowDialog,
    getVenda,
    registrarNotaFiscalDoPedido,
    registrarIsentoNotaFiscalDoPedido
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(DetalharVenda)